import { HStack, Icon, IconProps, Label } from '@medely/ui-kit';
import React from 'react';

export const ApplicationReceivedItem = ({
  text,
  iconName,
}: {
  text: string;
  iconName: IconProps['name'];
}) => {
  return (
    <HStack pb={2} gap={2}>
      <Icon name={iconName} color="text.primary" variant="custom" iconSize="18px" />
      <Label size="m">{text}</Label>
    </HStack>
  );
};
